import { AdDimension } from '@packages/common';
import { GooglePublisherTagProps } from './GooglePublisherTag';

export const DEFAULT_AD_DIMENSIONS: AdDimension[] = [
  [970, 250],
  [970, 90],
  [800, 250],
  [728, 90],
  [320, 150],
  [320, 100],
  [320, 75],
  [320, 50],
  [300, 250],
  [300, 150],
  [300, 100],
  [300, 75],
  [300, 50],
];

let idCounter = 0;
let googletag: any = null;
let loaded = false;

export const clear = () => {
  googletag = null;
  idCounter = 0;
};

export const getId = (props: GooglePublisherTagProps) => {
  return props.id || `gpt-${(idCounter += 1)}`;
};

export const getDimensions = (props: GooglePublisherTagProps, nodeWidth: number) => {
  const { dimensions, responsive } = props;
  return responsive ? dimensions.filter((dimension) => dimension[0] <= nodeWidth) : dimensions;
};

export const loadScript = () => {
  if (!loaded) {
    const gads = document.createElement('script');
    gads.async = true;
    gads.type = 'text/javascript';
    gads.src = '//www.googletagservices.com/tag/js/gpt.js';
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(gads);
  }
};

export const initGooglePublisherTag = (props: GooglePublisherTagProps) => {
  if (!googletag) {
    googletag = (window as any).googletag = (window as any).googletag || {};
    googletag.cmd = googletag.cmd || [];
    googletag.cmd.push(() => {
      if (props.enableSingleRequest) {
        googletag.pubads().enableSingleRequest();
      }
      googletag.pubads().enableAsyncRendering();
      googletag.pubads().collapseEmptyDivs();
      googletag.pubads().disableInitialLoad();
      googletag.enableServices();
    });
    loadScript();
    loaded = true;
  }
  return googletag;
};
